import { render, staticRenderFns } from "./WheelsItineraryItemAddress.vue?vue&type=template&id=6dc98ed2&scoped=true"
import script from "./WheelsItineraryItemAddress.vue?vue&type=script&setup=true&lang=ts"
export * from "./WheelsItineraryItemAddress.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WheelsItineraryItemAddress.vue?vue&type=style&index=0&id=6dc98ed2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc98ed2",
  null
  
)

export default component.exports